export const PREMIUM_SELLERS_WS_URL =
  process.env.REACT_APP_PREMIUM_SELLERS_WSS_URL

export const MEIC_WS_URL =
  process.env.REACT_APP_MEIC_WSS_URL


export const STREAMING_WS_URL =
  process.env.REACT_APP_STREAMING_WEBSOCKET_URL



